import { render, staticRenderFns } from "./addAgent.vue?vue&type=template&id=b6e9b9d8&scoped=true&"
import script from "./addAgent.vue?vue&type=script&lang=js&"
export * from "./addAgent.vue?vue&type=script&lang=js&"
import style0 from "./addAgent.vue?vue&type=style&index=0&id=b6e9b9d8&prod&lang=css&"
import style1 from "./addAgent.vue?vue&type=style&index=1&id=b6e9b9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e9b9d8",
  null
  
)

export default component.exports